module.exports = __webpack_public_path__ + "img/share_books.6713a5ef.png";